<template lang="pug">
  .b-buttons-row
    button.b-button._icon(
      type="button"
      @click="adjustScale(-1)"
      :disabled="layoutScale <= 0.5"
    )
      SVGIcon(:path="mdiMagnifyMinus")
    button.b-button._icon(
      type="button"
      @click="adjustScale(1)"
      :disabled="layoutScale >= 1"
    )
      SVGIcon(:path="mdiMagnifyPlus")
</template>
<script>
import SVGIcon from '@/components/icons/SVGIcon';
import { mdiMagnifyMinus, mdiMagnifyPlus } from '@mdi/js';
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
export default {
  name: 'ScaleButtons',
  components: { SVGIcon },
  data() {
    return {
      mdiMagnifyMinus,
      mdiMagnifyPlus,
    };
  },
  computed: {
    ...mapFields('scale', [
      'layoutScale',
    ]),
  },
  methods: {
    ...mapActions('scale', [
      'adjustScale',
    ]),
  },
};
</script>
